/**
 * @file index.tsx
 *
 * @fileoverview Renders breadcrumbs.
 */
import Link from '~/jobiqo/components/Link';
import BreadcrumbsSchema from '~/jobiqo/components/Breadcrumbs/components/Schema';
import {
  Breadcrumb as BreadcrumbComponent,
  BreadcrumbsWrapper,
} from '~/vcl/atoms/31-breadcrumbs';

export interface Breadcrumb {
  /**
   * The breadcrumb label.
   */
  label: string;
  /**
   * The breadcrumb relative path.
   */
  path: string;
}

interface BreadcrumbsProps {
  /**
   * The breadcrumbs items.
   */
  items: Breadcrumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <>
      <BreadcrumbsWrapper>
        {items.map(function ({ path, label }, index) {
          const isLast = index + 1 === items.length;

          return (
            <BreadcrumbComponent key={index} isLast={isLast}>
              {isLast ? label : <Link href={path}>{label}</Link>}
            </BreadcrumbComponent>
          );
        })}
      </BreadcrumbsWrapper>
      <BreadcrumbsSchema items={items} />
    </>
  );
}
export { Breadcrumbs };
